import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import { ConnectedRouter as Router } from 'connected-react-router'
import { Route } from 'react-router-dom'
import { Provider } from 'react-redux'
import { ConfigProvider } from "antd"
import uk_UA from 'antd/lib/locale-provider/uk_UA'
import { App } from './App'
import { store, history } from './store/configureStore'
import { init } from "./init"
import { StorageError } from "./components/StorageError"
import { unregister } from './serviceWorker'

import 'moment/locale/uk'
import './assets/scss/index.scss'


//test localStorage
try {
    localStorage.setItem('test', 'test')
    localStorage.removeItem('test')
    init(store).then(() => {
        ReactDOM.render(
            <Provider store={store}>
                <ConfigProvider locale={uk_UA}>
                    <Router history={history} >
                        <Route path="/" component={App}/>
                    </Router>
                </ConfigProvider>
            </Provider>, document.getElementById('root'))
        unregister()
    });
} catch (e) {
    ReactDOM.render(<StorageError/>, document.getElementById('root'));
}
